/**
 * =========================================================================================
 * HRMS - Help Desk - Reducer
 * =========================================================================================
 **/

import React from 'react';
import {requestTicket} from "ubs-framework/v2/common/convert";
import {HELP_DESK} from "../../common/constant";

const fields = {
    category: true,
    priority: true,
    tags: true,
    assignee: true,
    createdBy: true,
    workLogs: true,
    createdDate: true,
    dueDate: true,
    resolutionTimer: true,
};

const filters = {
    groupBy: 'status',
    view: 'list',
    search: '',
    dueDate: {
        startDate: null,
        endDate: null
    },
    createdAt: {
        startDate: null,
        endDate: null
    },
    category: null,
    status: null,
    tags: [],
    type: '',
    employee: null,
    ticket: 'openTicket',
    save: false,
}

const initialState = {
    userId: '',
    loading: false,
    filters: filters,
    myTicketFilter: filters,
    assignToMeFilter: filters,
    followerTicketFilter: filters,
    allTicketFilter: filters,
    companyFilters: {
        search: '',
        dueDate: {
            startDate: null,
            endDate: null
        },
        createdAt: {
            startDate: null,
            endDate: null
        },
        category: null,
        employee: null,
        priority: null,
        assignTo: null,
        ticket: 'openTicket'
    },
    fields: fields,
    myTicketFields: fields,
    assignToMeFields: fields,
    followerTicketFields: fields,
    allTicketFields: fields,
    ticketList: [],
    kanbanList: [],
    activeTimers: [],
    prevLayout: {},
};

export default function (state = initialState, action) {
    switch (action.type) {
        case 'AUTHENTICATE': {
            return {...state, userId: action.payload._id}
        }
        case 'SET_LOADING': {
            return {...state, loading: action.payload}
        }
        case 'SET_TICKET_LIST': {
            let ticketList = JSON.parse(JSON.stringify(state.ticketList))

            const newList = []
            if (ticketList?.length !== 0) {
                action?.payload?.ticketList?.map(e => {
                    const findIndex =  ticketList.findIndex(t => t?._id === e?._id)
                    if (findIndex > -1) {
                        ticketList[findIndex].tickets = [...ticketList[findIndex].tickets, ...e?.tickets]
                    } else {
                        newList.push(e)
                    }
                })
                if (action?.payload?.ticketList?.length === 0) ticketList = action?.payload?.ticketList
            } else ticketList = action?.payload?.ticketList ?? []

            if (newList?.length !== 0) ticketList.push(...newList)

            return {...state, ticketList}
        }
        case 'SET_TICKET_KANBAN_LIST': {
            let kanbanList = JSON.parse(JSON.stringify(state.kanbanList))

            if (action.payload?.length > 1) {
                kanbanList = action?.payload
            } else if (action.payload?.length === 1) {
                let findStatus = kanbanList?.find(e => e?.status === action.payload[0]?.status)
                if (findStatus && action?.payload[0]?.ticketList?.length > 0) {
                    kanbanList = kanbanList.map(e => {
                        if (e?.status === findStatus?.status) {
                            // kanban ticket drag and drop. than get ticket list api call current page 1 that's why skip current page 1
                            if (action?.payload[0]?.currentPage !== 1) {
                                e.ticketList = [...e.ticketList, ...action?.payload[0]?.ticketList]
                            } else {
                                e.ticketList = action?.payload[0]?.ticketList
                            }
                        }
                        return e
                    })
                }
            } else kanbanList = action?.payload
            return {...state, kanbanList}
        }
        case 'UPDATE_TICKET_LIST': {
            let ticketList = JSON.parse(JSON.stringify(state.ticketList));
            let filters = {};
            const kanbanList = JSON.parse(JSON.stringify(state.kanbanList));
            const localState = {}

            const ticketInfo = action?.payload?.ticketInfo
            const checkParentTicket = action?.payload?.ticketInfo?.parentTicket

            if (HELP_DESK.TICKET_TYPE[window.location.pathname.split('/')[3]] === "myTickets") {
                filters = state.myTicketFilter
            } else if (HELP_DESK.TICKET_TYPE[window.location.pathname.split('/')[3]] === "assignToMe") {
                filters = state.assignToMeFilter
            } else if (HELP_DESK.TICKET_TYPE[window.location.pathname.split('/')[3]] === "followerTicket") {
                filters = state.followerTicketFilter
            } else if (HELP_DESK.TICKET_TYPE[window.location.pathname.split('/')[3]] === "allTickets") {
                filters = state.allTicketFilter
            }

            let findStatusIndex = -2
            if (filters.view === 'list') {
                findStatusIndex = ticketList.findIndex(t => t?._id === ticketInfo?.status)
            } else if (filters.view === 'kanban') {
                findStatusIndex = kanbanList.findIndex(t => t?.status === ticketInfo?.status)
            }

            /** Case
             * 1: Add Ticket
             * 2: Update Ticket
             * 3: Delete Ticket
             * 4: open and resolved Ticket
             */
            switch (action?.payload?.action) {
                case 1 : {
                    if (!checkParentTicket && checkTicketFilter(filters, ticketInfo, state.userId)) {
                        if (findStatusIndex > -1) {
                            if (filters.view === 'list') {
                                ticketList[findStatusIndex].tickets.push(ticketInfo)
                            } else if (filters.view === 'kanban') {
                                kanbanList[findStatusIndex].ticketList.push(ticketInfo)
                                kanbanList[findStatusIndex].totalRecords = kanbanList[findStatusIndex].totalRecords + 1
                            }
                        } else {
                            if (filters.view === 'list') {
                                ticketList.push({_id: ticketInfo?.status, tickets: [ticketInfo]})
                            } else if (filters.view === 'kanban') {
                                kanbanList.push({
                                    ...requestTicket(filters),
                                    status: ticketInfo?.status,
                                    ticketList: [ticketInfo],
                                    totalRecords: 1
                                })
                            }
                        }
                    }
                    break;
                }
                case 2 : {
                    if (!checkParentTicket && checkTicketFilter(filters, ticketInfo, state.userId)) {
                        let update = false
                        const conditions = [];
                        if (filters?.tags?.length) filters?.tags?.map(e => conditions.push(ticketInfo?.tags?.includes(e?._id)));
                        // conditions.push(ticketInfo?.followerIds?.includes(state.userId))
                        const checkFiler = conditions.every(e => e);

                        if (filters.view === 'list') {
                            ticketList.map((e, index) => {
                                e?.tickets?.map((t, i) => {
                                    if (t?._id === ticketInfo?._id) {
                                        if (ticketInfo?.status === e?._id && checkFiler) ticketList[index].tickets[i] = ticketInfo;
                                        else {
                                            update = true
                                            ticketList[index].tickets.splice(i, 1);
                                            // if (ticketList[index].tickets?.length === 0) ticketList.splice(index, 1)
                                        }
                                    }
                                })
                            })
                        } else if (filters.view === 'kanban') {
                            kanbanList.map((e, index) => {
                                e?.ticketList?.map((t, i) => {
                                    if (t?._id === ticketInfo?._id) {
                                        if (ticketInfo?.status === e?.status && checkFiler) kanbanList[index].ticketList[i] = ticketInfo;
                                        else {
                                            update = true
                                            kanbanList[index].ticketList.splice(i, 1);
                                            kanbanList[index].totalRecords = kanbanList[index].totalRecords - 1
                                            // if (kanbanList[index].ticketList?.length === 0) kanbanList.splice(index, 1)
                                        }
                                    }
                                })
                            })
                        }
                        if (checkFiler) {
                            if (findStatusIndex > -1) {
                                if (update) {
                                    if (filters.view === 'list') {
                                        ticketList[findStatusIndex]?.tickets?.push(ticketInfo)
                                    } else if (filters.view === 'kanban') {
                                        kanbanList[findStatusIndex]?.ticketList?.push(ticketInfo)
                                        kanbanList[findStatusIndex].totalRecords = kanbanList[findStatusIndex].totalRecords + 1
                                    }
                                }
                            } else {
                                if (filters.view === 'list') {
                                    ticketList.push({_id: ticketInfo?.status, tickets: [ticketInfo]})
                                } else if (filters.view === 'kanban') {
                                    kanbanList.push({
                                        ...requestTicket(filters),
                                        status: ticketInfo?.status,
                                        ticketList: [ticketInfo],
                                        totalRecords: 1
                                    })
                                }
                            }
                        }
                    }
                    break;
                }
                case 3 : {
                    if (!checkParentTicket && checkTicketFilter(filters, ticketInfo, state.userId)) {
                        if (filters.view === 'list') {
                            ticketList.map((e, index) => {
                                e?.tickets?.map((t, i) => {
                                    if (t?._id === ticketInfo?._id) {
                                        ticketList[index].tickets.splice(i, 1);
                                        // if (ticketList[index].tickets?.length === 0) ticketList.splice(index, 1)
                                    }
                                })
                            })
                        } else if (filters.view === 'kanban') {
                            kanbanList.map((e, index) => {
                                e?.ticketList?.map((t, i) => {
                                    if (t?._id === ticketInfo?._id) {
                                        kanbanList[index].ticketList.splice(i, 1);
                                        kanbanList[index].totalRecords = kanbanList[index].totalRecords !== 1 ? kanbanList[index].totalRecords - 1 : 0
                                        // if (kanbanList[index].ticketList?.length === 0) kanbanList.splice(index, 1)
                                    }
                                })
                            })
                        }
                    }
                    break;
                }
                case 4 : {
                    if (!checkParentTicket && checkTicketFilter(filters, ticketInfo, state.userId)) {
                        const ticketResolvedAction = action?.payload?.ticketResolvedAction
                        if (ticketResolvedAction === 'open') {
                            ticketList = updateOpenTickets(ticketList, ticketInfo, filters.ticket ?? '')
                        } else if (ticketResolvedAction === 'resolved') {
                            ticketList = updateResolvedTickets(ticketList, ticketInfo, filters.ticket ?? '')
                        }
                    }
                    break;
                }
                default:
                    break;
            }

            return {...state, ...localState, ticketList, kanbanList}
        }
        case 'SET_TICKET_FILTER': {
            const localState = {}

            const component = action?.component ?? ''
            if (component === 'myTickets') {
                localState.myTicketFilter = {...state.myTicketFilter, ...action.payload}
            } else if (component === 'assignToMe') {
                localState.assignToMeFilter = {...state.assignToMeFilter, ...action.payload}
            } else if (component === 'followerTicket') {
                localState.followerTicketFilter = {...state.followerTicketFilter, ...action.payload}
            } else if (component === 'allTickets') {
                localState.allTicketFilter = {...state.allTicketFilter, ...action.payload}
            }

            return {...state, filters: {...state.filters, ...action.payload}, ...localState}
        }
        case 'SET_COMPANY_FILTER': {
            return {...state, companyFilters: {...state.companyFilters, ...action.payload}}
        }
        case 'SET_TICKET_FIELDS': {
            const localState = {}

            const component = action?.component ?? ''
            if (component === 'myTickets') {
                localState.myTicketFields = {...state.myTicketFields, ...action.payload}
            } else if (component === 'assignToMe') {
                localState.assignToMeFields = {...state.assignToMeFields, ...action.payload}
            } else if (component === 'followerTicket') {
                localState.followerTicketFields = {...state.followerTicketFields, ...action.payload}
            } else if (component === 'allTickets') {
                localState.allTicketFields = {...state.allTicketFields, ...action.payload}
            }

            return {...state, ...localState}
        }
        case 'SET_ACTIVE_TIMER_INFO': {
            let activeTimers = JSON.parse(JSON.stringify(state.activeTimers))
            const ticketList = JSON.parse(JSON.stringify(state.ticketList));
            const localState = {}

            if (action?.remove) {
                localState.activeTimers = activeTimers.filter(e => e._id !== action.payload?._id)

                if (action?.payload?.duration) {
                    localState.ticketList = ticketList?.map(e => {
                        e.tickets = e?.tickets?.map(t => {
                            if (t._id === action.payload.ticket) t.duration = t.duration ? (t.duration + action.payload.duration) : action.payload.duration
                            return t;
                        })
                        return e
                    });
                }
            } else {
                activeTimers = [...activeTimers, ...action.payload]
                localState.activeTimers = activeTimers.filter((v, i, a) => a.findIndex(t => (t._id === v._id)) === i)
            }

            return {...state, ...localState};
        }
        case 'SET_SAVE_LAYOUT_INFO': {
            let localState = {}

            const layout = action?.payload?.layoutInfo?.layout
            if (layout) {
                localState = {
                    ...(layout?.myTicketFilter && {
                        myTicketFilter: {...state.myTicketFilter, save: true, ...layout?.myTicketFilter},
                        myTicketFields: {...state.myTicketFields, ...layout?.myTicketFields},
                        prevLayout: {...layout},
                    }),
                    ...(layout?.assignToMeFilter && {
                        assignToMeFilter: {...state.assignToMeFilter, save: true, ...layout?.assignToMeFilter},
                        assignToMeFields: {...state.assignToMeFields, ...layout?.assignToMeFields},
                        prevLayout: {...layout},
                    }),
                    ...(layout?.followerTicketFilter && {
                        followerTicketFilter: {...state.followerTicketFilter, save: true, ...layout?.followerTicketFilter},
                        followerTicketFields: {...state.followerTicketFields, ...layout?.followerTicketFields},
                        prevLayout: {...layout},
                    }),
                    ...(layout?.allTicketFilter && {
                        allTicketFilter: {...state.allTicketFilter, save: true, ...layout?.allTicketFilter},
                        allTicketFields: {...state.allTicketFields, ...layout?.allTicketFields},
                        prevLayout: {...layout},
                    }),
                }
            } else {
                // localState = {
                //     myTicketFilter: {...state.myTicketFilter, save: true},
                //     assignToMeFilter: {...state.assignToMeFilter, save: true},
                //     followerTicketFilter: {...state.followerTicketFilter, save: true},
                //     allTicketFilter: {...state.allTicketFilter, save: true},
                //     prevLayout: {
                //         myTicketFilter: {...state.myTicketFilter, save: true},
                //         assignToMeFilter: {...state.assignToMeFilter, save: true},
                //         followerTicketFilter: {...state.followerTicketFilter, save: true},
                //         allTicketFilter: {...state.allTicketFilter, save: true},
                //     }
                // }
                const checkSaveValue = data => !state[data].save
                if (checkSaveValue('myTicketFilter')) {
                    localState.myTicketFilter = {...state.myTicketFilter, save: true}
                    localState.prevLayout = {...(localState.prevLayout ?? {}),myTicketFilter: localState.myTicketFilter}
                }
                if (checkSaveValue('assignToMeFilter')) {
                    localState.assignToMeFilter = {...state.assignToMeFilter, save: true}
                    localState.prevLayout = {...(localState.prevLayout ?? {}),assignToMeFilter: localState.assignToMeFilter}
                }
                if (checkSaveValue('followerTicketFilter')) {
                    localState.followerTicketFilter = {...state.followerTicketFilter, save: true}
                    localState.prevLayout = {...(localState.prevLayout ?? {}),followerTicketFilter: localState.followerTicketFilter}
                }
                if (checkSaveValue('allTicketFilter')) {
                    localState.allTicketFilter = {...state.allTicketFilter, save: true}
                    localState.prevLayout = {...(localState.prevLayout ?? {}),allTicketFilter: localState.allTicketFilter}
                }

            }

            return {...state, ...localState};
        }
        case 'SET_PREV_LAYOUT_INFO': {
            const localState = {
                prevLayout: {}
            }
            const layout = action?.payload?.layoutInfo?.layout

            if (layout) {
                if (action?.payload?.layoutInfo?.component === 'myTickets') {
                    localState.prevLayout.myTicketFilter = layout?.myTicketFilter
                    localState.prevLayout.myTicketFields = layout?.myTicketFields
                } else if (action?.payload?.layoutInfo?.component === 'assignToMe') {
                    localState.prevLayout.assignToMeFilter = layout?.assignToMeFilter
                    localState.prevLayout.assignToMeFields = layout?.assignToMeFields
                } else if (action?.payload?.layoutInfo?.component === 'followerTicket') {
                    localState.prevLayout.followerTicketFilter = layout?.followerTicketFilter
                    localState.prevLayout.followerTicketFields = layout?.followerTicketFields
                } else if (action?.payload?.layoutInfo?.component === 'allTickets') {
                    localState.prevLayout.allTicketFilter = layout?.allTicketFilter
                    localState.prevLayout.allTicketFields = layout?.allTicketFields
                }
            }

            return {...state, ...localState}
        }
        default:
            return state;
    }
}

export const checkTicketFilter = (filters, ticketInfo, userId) => {
    let conditions = [];
    if (filters?.search && filters?.search?.length > 2) {
        const pattern = new RegExp(filters?.search?.toLowerCase());
        conditions.push(!!ticketInfo?.name?.toLowerCase()?.match(pattern) || !!ticketInfo?.description?.toLowerCase()?.match(pattern) || !!ticketInfo?.number?.toLowerCase()?.match(pattern));
    }

    if (filters?.status && filters?.status?._id) conditions.push(filters?.status?._id === ticketInfo?.status)
    if (filters?.category && filters?.category?._id) conditions.push(filters?.category?._id === ticketInfo?.category)
    if (filters?.employee && filters?.employee?._id) conditions.push(filters?.employee?._id === ticketInfo?.createdBy)

    switch (filters.type) {
        case 'myTickets':
            conditions.push(userId === ticketInfo?.createdBy)
            break;
        case 'assignToMe':
            conditions.push(userId === ticketInfo?.assignTo)
            break;
        case 'followerTicket':
            conditions.push(userId !== ticketInfo?.assignTo && userId !== ticketInfo?.createdBy && ticketInfo?.followerIds?.includes(userId))
            break;
        default:
            break;
    }

    if (filters.dueDate.startDate && filters.dueDate.endDate) {
        conditions.push(new Date(ticketInfo?.dueDate).getTime() >= filters.dueDate.startDate && new Date(ticketInfo?.dueDate).getTime() <= filters.dueDate.endDate)
    }
    if (filters.createdAt.startDate && filters.createdAt.endDate) {
        conditions.push(new Date(ticketInfo?.createdAt).getTime() >= filters.createdAt.startDate && new Date(ticketInfo?.createdAt).getTime() <= filters.createdAt.endDate)
    }
    // if (filters?.tags?.length) filters?.tags?.map(e => conditions.push(ticketInfo?.tags?.includes(e?._id)))
    return conditions.every(e => e);
}

const updateOpenTickets = (list, info, filter) => {
    const findStatusIndex = list.findIndex(t => t?._id === info?.status)

    if (filter === "resolvedTicket") {
        list = list?.map(l => {
            l.tickets = l?.tickets?.filter(e => e._id !== info._id)
            return l
        })
    }
    else if (filter === "openTicket") {
        if (findStatusIndex !== -1) {
            const i = list?.map(t => t?.tickets)?.findIndex(e => e._id === info._id)
            if (i === -1) {
                if (findStatusIndex !== -1) {
                    list[findStatusIndex]?.tickets?.push(info)
                } else list.push({_id: info?.status, tickets: [info]})
            }
        } else list.push({_id: info?.status, tickets: [info]})
    } else list = updateTicketList(list, info)
    return list
}

const updateResolvedTickets = (list, info, filter) => {
    const findStatusIndex = list.findIndex(t => t?._id === info?.status)

    if (filter === "openTicket") {
        list = list?.map(l => {
            l.tickets = l?.tickets?.filter(e => e._id !== info._id)
            return l
        })
    }
    else if (filter === "resolvedTicket") {
        if (findStatusIndex !== -1) {
            const i = list?.map(t => t?.tickets)?.findIndex(e => e._id === info._id)
            if (i === -1) {
                if (findStatusIndex !== -1) {
                    list[findStatusIndex]?.tickets?.push(info)
                } else list.push({_id: info?.status, tickets: [info]})
            }
        } else list.push({_id: info?.status, tickets: [info]})
    } else list = updateTicketList(list, info)
    return list
}

const updateTicketList = (list, info) => {

    const findStatusIndex = list.findIndex(t => t?._id === info?.status)
    list = list?.map(l => {
        l.tickets = l?.tickets?.filter(e => e._id !== info._id)
        return l
    })
    if (findStatusIndex !== -1) {
        list[findStatusIndex]?.tickets?.push(info)
    } else {
        list.push({_id: info?.status, tickets: [info]})
    }
    return list
}
